module.exports = __webpack_public_path__ + "5ad8b6c154f6ad08924428537b89dfd8.svg";